<template>
  <div>
    <Modal
      ref="modal"
      title="Deactivate teammate"
      body="Are you sure you want to deactivate this teammate? Deactivating a teammate removes them from your active team."
      action="Deactivate"
      action-color="red"
      @close-modal="handleCancel"
      @handle-action="handleDeactivate"
    />
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    Modal,
  },
  data() {
    return {};
  },
  methods: {
    handleDeactivate() {
      const self = this;
      fetch(`/api/teammates/${self.$route.params.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          teammate_status: 'Inactive',
        }),
      })
        .then(response => response.json())
        .then(async data => {
          if (data.status != 'error') {
            self.$emit('handleContactDeactivate');
            self.$refs.modal.success();
            await self.$router.push('/teammates?sort=created&order=desc&status=Active');
            toast.success('Teammate deactivated', {
              action: { label: 'Dismiss' },
              description: 'Your teammate was successfully deactivated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$refs.modal.error();
            toast.error('Teammate deactivate error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactDeactivateCancel');
    },
  },
};
</script>
